import React, { ReactElement } from 'react';

import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const SenseCheckCom = React.lazy(() => import('../components/SenseCheck'));

function SenseCheck(): ReactElement {
  return (
    <SuspenseLoadPage>
      <SenseCheckCom />
    </SuspenseLoadPage>
  );
}

export default SenseCheck;
